import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { DocumentView } from './DocumentView';
import * as HELPER from '@src/config/helper';
import { DOCUMENT_CATEGORY,OCR_EXIST_PARENT_ID } from '@src/config/constant';
import DocumentErrorModal from './DocumentErrorModal';

export const DocumentForm = forwardRef((props: any, ref) => {
    const [inputField, setInputField] = useState<any>({ ...props?.documents })
    const [showErrorPopup, setShowErrorPopup] = useState(false)
    const [docList, setDocList] = useState([])

    const handleFileChange = async (e: any, fieldItem: any,uploadIndex: any = null) => {
        let selectedFile = e.target.files;
        let validateFile = await HELPER.ValidateFileInput(selectedFile)

        if (validateFile) {
            e.target.value = null
            setShowErrorPopup(true)
            return
        }
        let maxSelectedFiles = inputField[fieldItem.value] ? Array.from(inputField[fieldItem.value]).concat(Array.from(selectedFile)) : selectedFile
        if(uploadIndex !== null) {
           const existing = Array.from(inputField[fieldItem.value] || []);
           existing[uploadIndex] = selectedFile[0];
            maxSelectedFiles = existing;
        }
        let oldFilesResubmission = 0
        let childItem= fieldItem?.child.find((el:any)=>el.value===fieldItem.value);
        //resubmission case
        //to add old images count before max upload check
        if (props?.resubmissionLeadId) {
            oldFilesResubmission = fieldItem?.src?.filter((e: any) => !inputField?.['deletedItems']?.includes(e.id))?.length || 0
        }

        if (fieldItem.max_upload) {
            let maxUpload=(fieldItem.parent_id===OCR_EXIST_PARENT_ID)?childItem.max_upload:fieldItem.max_upload;
            if ((maxSelectedFiles.length + oldFilesResubmission) > maxUpload) {
                // setErrField({ ...errField, [fieldItem.value]: `Maximum ${fieldItem.max_upload} Documents are allowed` })
                props.setDocumentErrors({ ...props.errors, [fieldItem.value]: `Maximum ${fieldItem.max_upload} Documents are allowed` })
                e.target.value = null
            }
            else {
                const value = { ...inputField, [fieldItem.value]: maxSelectedFiles }
                setInputField(value)

                let errros = { ...props.setDocumentErrors }
                delete errros?.[fieldItem.value]
                props.setDocumentErrors(errros)

                if (fieldItem.value === DOCUMENT_CATEGORY['orcr']) {
                    props?.setOrcrApiCall(false)
                }
            }
        }
    }

    const addResubmissionComments = (fieldItem: any, comment: any) => {
        setInputField((prev: any) => ({ ...prev, 'comments': { ...prev?.comments, [fieldItem.value]: comment } }))
    }

    const updateSelectedFiles = (files: any) => {
        setInputField({ ...files })
        // props?.setDocuments(files)
    }

    useEffect(() => {
        if (props?.errors && Object.keys(props.errors || {})?.length) {
            setShowErrorPopup(true)
        } else setShowErrorPopup(false)
        //eslint-disable-next-line
    }, [props.errors])

    useEffect(() => {
        if (props?.docList?.length) {
            setDocList(props?.docList)
        }
    }, [props?.docList])

    useImperativeHandle(ref, () => ({
        getData: () => inputField
    }))

    return (
        <>
            <div className='col-md-12 w-100'>
                <DocumentView docList={docList} errField={props.errors} handleFileChange={handleFileChange} filesData={inputField} updateSelectedFiles={updateSelectedFiles} for={"agency"} setOrcrApiCall={props.setOrcrApiCall} updateDocList={props.updateDocList} addComment={addResubmissionComments} />
            </div>
            <DocumentErrorModal show={showErrorPopup} handleClose={() => setShowErrorPopup(false)} errors={props.errors} />
        </>
    )
})